import * as React from 'react';

var _mask, _path, _g, _path2, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgMxn = function SvgMxn(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip0_5422_28815)"
    }, _mask || (_mask = /*#__PURE__*/ React.createElement("mask", {
        id: "path-1-outside-1_5422_28815",
        width: 20,
        height: 16,
        x: 2.4,
        y: 4.8,
        fill: "#000",
        maskUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M2.4 4.8h20v16h-20z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M2.4 5.8a1 1 0 0 1 1-1h17.2a1 1 0 0 1 1 1v12.4a1 1 0 0 1-1 1H3.4a1 1 0 0 1-1-1z"
    }))), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_5422_28815",
        width: 20,
        height: 16,
        x: 2,
        y: 4,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "luminance"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M2.4 4.8h19.2v14.4H2.4z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_5422_28815)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#D9071E",
        fillRule: "evenodd",
        d: "M15.6 4.8h6v14.4h-6z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#006923",
        fillRule: "evenodd",
        d: "M2.4 4.8h7.2v14.4H2.4z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M8.4 4.8h7.2v14.4H8.4z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FCCA3D",
        fillRule: "evenodd",
        d: "M11.03 9.548s-.411.32-.334.66.889 0 .79-.33c-.097-.33-.455-.33-.455-.33",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#A8AC71",
        fillRule: "evenodd",
        d: "M10.402 10.36c-.308 0-.437-.256-.373-.53.034-.146.122-.33.267-.571l.514.309a4 4 0 0 0-.131.237c.108.032.214.079.3.136.28.184.384.513.083.757-.058.047-.152.207-.204.362a.7.7 0 0 1 .34.085c.265.157.24.443.038.664a1.35 1.35 0 0 1-.514.349c-.3.108-.62.067-.62-.317v-.003c0-.015-.002-.042.132-.045-.228-.003-.277-.124-.306-.34a2 2 0 0 1-.014-.218c-.002-.072-.002-.072-.006-.143v-.016c-.005-.07-.008-.117.147-.117h-.348v-.6h.348c.197 0 .307.066.37.204q.052-.094.112-.174a.5.5 0 0 0-.135-.028m.382 1.054.01-.01-.004.005zm-.263.178h.001m.001-.226.001.01-.002-.018zm-.262.427h-.026.026",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#8F4620",
        fillRule: "evenodd",
        d: "M13.96 12.242s.556-1.645-.326-2.497-1.902-.794-1.902-.794-.294.218 0 .384c.294.167.17.326.17.326s-.491-.499-.817-.207c-.327.291.304.247.237.467-.066.22-.35 1.194.064 1.686.414.493-.39.386-.227.386s.744.114.744 0c0-.115.201.445.374.445s.306-.197.306-.197.242.197.39.197c.147 0 .66-.129.66-.129l-.971-.818s.059-.361-.08-.44c-.137-.078 1.106.693 1.203.942.098.248.176.248.176.248",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#9FAB2F",
        d: "M9.041 11.836s.09-.287.187-.307c.083-.018.259.137.259.137.312 1.734 1.067 2.411 2.32 2.411 1.266 0 2.034-.514 2.482-2.113 0 0 .239-.244.323-.217.091.03.206.352.206.352-.115 1.87-1.465 2.978-2.991 2.978-1.541 0-2.8-1.242-2.786-3.241"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2FC2DC",
        fillRule: "evenodd",
        d: "M10.402 12.994s1.803.382 2.515.382c.711 0-.625.58-1.146.58s-1.369-.962-1.369-.962",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 1.2,
        height: 0.643,
        x: 11.201,
        y: 13.26,
        fill: "#F9AA51",
        rx: 0.083
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#259485",
        d: "m9.707 12.081.491-.344c.64.911 1.595 1.21 2.932.898l.137.584c-1.563.366-2.771-.013-3.56-1.138"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FCCA3D",
        fillRule: "evenodd",
        d: "M12.357 12.21s-.728.383-.486.383c.243 0 1.193.192 1.008 0-.185-.191-.522-.383-.522-.383M11.496 11.753s-.139-.4-.427-.4-.206.328-.345.328.13.23.249.23.523-.158.523-.158",
        clipRule: "evenodd"
    })))), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#111827",
        fillOpacity: 0.1,
        d: "M2.4 4.8h19.2zm19.2 13.4a2 2 0 0 1-2 2H4.4a2 2 0 0 1-2-2h19.2m-19.2 1V4.8zM21.6 4.8v14.4z",
        mask: "url(#path-1-outside-1_5422_28815)"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_5422_28815"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M2.4 5.8a1 1 0 0 1 1-1h17.2a1 1 0 0 1 1 1v12.4a1 1 0 0 1-1 1H3.4a1 1 0 0 1-1-1z"
    })))));
};

export { SvgMxn as ReactComponent };
//# sourceMappingURL=MXN.svg.es.js.map
